{
  "update-password-pin-dialog": {
    "buttons": {
      "resend": "Resend",
      "submit": "Submit"
    },
    "text": {
      "enter-pin": "Please enter PIN code to confirm your new password.",
      "in-second": "in {{seconds}} s",
      "password-updated": "Password has been updated successfully!",
      "pin-via-email": "The PIN code is sent to your email",
      "pin-via-sms": "The PIN code is sent to your phone number",
      "update-password": "Update password"
    }
  }
}
